export const divisionTypes = {
  PAINT: "Paint",
  CLEAN: "Clean",
  SHAMPOO: "Shampoo",
  HALLWAY_CLEAN: "Hallway Clean",
  ALL: "All",
};
